<template>
  <div>
    <div v-if="objBaseInfo.channelId == 'WEB'">
      <el-popover popper-class="dest-popover" v-model:visible="visible"  width="620" trigger="manual">
        <div v-if="showCityHot" @click="visible = false">
          <div class="title" v-if="showrecentCityData" style="display: flex; justify-content: space-between;align-items: center;">
            <p>{{ $t("DESTINATION.SEARCHRECORDS") }}</p>
            <div style="display: flex; justify-content: space-between;align-items: center;" @click="revoveRecentRecord">
              <i class="el-icon-delete"></i>
              <p style="padding-right: 15px;padding-left: 5px;font-size: 12px;color: #777c7f;">{{ $t("DESTINATION.CLEARHISTORY") }}</p>
            </div>
          </div>
          <ul class="scroll_hot">
            <li v-for="item in recentCityData" :key="item.cityCode">
              <span @click="toParam(item)" class="city-span">{{
                item.cityNameLists[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]
              }}</span>
            </li>
          </ul>
          <p v-if="objBaseInfo.destinationType == 'D'" class="title">{{ $t("DESTINATION.INHOTCITY") }}</p>
          <p v-if="objBaseInfo.destinationType == 'I'" class="title">{{ $t("DESTINATION.OUTHOTCITY") }}</p>
            <ul class="scroll_hot">
              <li v-for="item in inCityData" :key="item.cityCode">
                <span @click="toParam(item)" class="city-span" 
                :title="item.cityNameLists[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]">
                {{item.cityNameLists[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]}}
                </span>
              </li>
            </ul>
        </div>
        <div @click="visible = false" v-if="showSelectContent" class="selectContent">
          <span v-if="$i18n.locale == 'zh'">
            <el-row
              @click="toParam(item, 'search')"
              v-for="(item, index) in resultList"
              :key="index"
              class="item-select-row"
            >
              <el-col :span="2" class="item-icon-size"
                ><svg-icon :icon-class="getIcon(item.locationType)"></svg-icon
              ></el-col>
              <el-col :span="15">
                <el-row>
                  <el-col :span="24">
                    <span class="item-name-span">
                      {{ item.locationCnName }}</span
                    >
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <span class="item-next-span">
                      {{ ((item.locationType != 0 && item.locationType != 2)? (item.cityCnName + ", ") : "") + item.provinceCnName + ", " + item.countryCnName }}</span
                    >
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7"
                ><span class="item-type-span">{{
                  getLocationType(item.locationType)
                }}</span>
              </el-col>
            </el-row>
          </span>
          <span v-if="$i18n.locale == 'en'">
            <el-row
              @click="toParam(item, 'search')"
              v-for="(item, index) in resultList"
              :key="index"
              class="item-select-row"
            >
              <el-col :span="2" class="item-icon-size"
                ><svg-icon :icon-class="getIcon(item.locationType)"></svg-icon
              ></el-col>
              <el-col :span="15">
                <el-row>
                  <el-col :span="24">
                    <span class="item-name-span">
                    {{ item.locationEnName }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <span class="item-next-span">
                    {{ ((item.locationType != 0 && item.locationType != 2) ? (item.cityEnName + ", ") : "") + item.provinceEnName + ", " + item.countryEnName }}</span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7"
                ><span class="item-type-span">{{ getLocationType(item.locationType) }}</span>
              </el-col>
            </el-row>
          </span>
        </div>
        <div style="text-align: center; color: #b3acac">{{ tipMessage }}</div>
        
        <template #reference>
          <el-input
            :placeholder="$t('SEARCH.DESTINATION')"
            @input="querySearch"
            v-model="returnParent"
            autocomplete="off"
            @click="clickDest"
            @blur="visible = false"
          >
            <template #prefix>
              <svg-icon
                icon-class="location"
              ></svg-icon>
            </template>
          </el-input>
        </template>
      </el-popover>
    </div>
    <div @click="MobileInputClick" v-if="objBaseInfo.channelId == 'MOBILE'">
      <el-input
        v-if="!isDisplayText"
        :placeholder="$t('SEARCH.DESTINATION')"
        v-model="returnParent"
        autocomplete="off"
        :readonly="true"
      >
        <template #prefix>
          <svg-icon
            icon-class="location"
          ></svg-icon>
        </template>
      </el-input>
      <!-- resultSearch 使用-->
      <p v-if="isDisplayText" class="list_city">{{ resultMobile }}</p>
    </div>
    <van-popup
      v-model:show="destPopShow"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div ref="container">
        <van-sticky :container="container">
          <form>
            <van-search
              v-model="searchCity"
              show-action
              :placeholder="$t('DESTINATION.SEARCHPL')"
              @update:model-value="onInput"
              @cancel="onCancel"
            >
              <template #action>
                <div @click="onClosePop">{{ $t("DESTINATION.CLOSEPOP") }}</div>
              </template>
            </van-search>
          </form>
        </van-sticky>
        <van-index-bar :index-list="[]">
          <span v-if="showrecentCityData">
            <van-index-anchor index=" " :style="{ background: '#f3efef' }">{{ $t("DESTINATION.SEARCHRECORDS") }}</van-index-anchor>
            <i style="font-size: 18px;position: absolute;right: 1.6rem;top: 6rem;" class="el-icon-delete" @click="revoveRecentRecord"></i>
            <ul style="margin: 1.4rem;">
              <li v-for="(item, indexNo) in recentCityData" :key="'hot' + indexNo">
                <span @click="toParam(item)" class="city-span">{{
                  item.cityNameLists[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]
                }}</span>
              </li>
            </ul>
          </span>
          <span v-if="showMobileHot">
            <van-index-anchor v-if="objBaseInfo.destinationType == 'D'" index=" " :style="{ background: '#f3efef' }">{{ $t("DESTINATION.INHOTCITY") }}</van-index-anchor>
            <van-index-anchor v-if="objBaseInfo.destinationType == 'I'" index=" " :style="{ background: '#f3efef' }">{{ $t("DESTINATION.OUTHOTCITY") }}</van-index-anchor>
            <ul style="margin: 1.4rem;">
              <li v-for="(item, indexNo) in inCityData" :key="'hot' + indexNo">
                <span @click="toParam(item)" class="city-span">{{
                  item.cityNameLists[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]
                }}</span>
              </li>
            </ul>
          </span>
          <!-- v-for="item in indexCityInfoList" :key="item.indexItem" -->
          <span>
            <!-- <van-index-anchor v-if="item.cityList.length > 0" :index="item.indexItem" :style="{ background: '#f3efef' }" /> -->
            <span v-if="$i18n.locale == 'zh'">
              <van-cell
                v-for="item in indexCityInfoList"
                :key="item.id"
                :title="item.locationCnName"
                @click="toParam(item, 'search')"
                class="city-span"
                :value="getLocationType(item.locationType)"
                :label="getCityLable(item)"
              >
                <template #icon>
                  <svg-icon :icon-class="getIcon(item.locationType)"></svg-icon>
                </template>
              </van-cell>
            </span>
            <span v-if="$i18n.locale == 'en'">
              <van-cell
                v-for="item in indexCityInfoList"
                :key="item.id"
                :title="item.locationEnName"
                @click="toParam(item, 'search')"
                class="city-span"
                :value="getLocationType(item.locationType)"
                :label="getCityLable(item)"
              >
                <template #icon>
                  <svg-icon :icon-class="getIcon(item.locationType)"></svg-icon>
                </template>
              </van-cell>
            </span>
            <div style="text-align: center; color: #b3acac;font-size: 14px;">{{ tipMessage }}</div>
          </span>
        </van-index-bar>
      </div>
    </van-popup>
    <ConfirmBoxss
      :centerDialogVisible="confirmFlags"
      :confirmMsg="confirmMsgs"
      @setConfirmFlag="setConfirmFlags"
    ></ConfirmBoxss>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import ConfirmBoxss from "@/components/confirmBoxs.vue";
import { cityList, searchDestination,getcountryList,revoveRecentRecords } from "../api/shoppingData.js";
import "vant/lib/index-anchor/style/index";
import { getCityInfoByCode } from "@/utils/utils";

export default {
  name: "Destination",
  components: {
    ConfirmBoxss,
  },
  props: {
    returnParentValue: String,
    parentCityCode: String,
    defaultSearchValue:{
      type: String,
      default: "",
    },
    isDisplayText: {
      type: Boolean,
      default: false,
    },
    //仅显示城市搜索结果
    isOnlyCity: {
      type: Boolean,
      default: true,
    },
    //是否显示热门城市 以及搜索是否区分国内国际
    isHotCity: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      confirmMsgs: "", //提示消息内容
      confirmFlags: false, //提示框是否弹出
      showCityHot: true, //热门城市是否显示
      showSelectContent: false, //下拉框选择
      restaurants: [],
      newResultList: [],
      resultList: [],
      returnParent: "",
      cityCode: "",
      visible: false,
      inCityData: [],
      tipMessage: "",
      destPopShow: false,
      indexCityInfoList: [],
      searchCity: "",
      originCityList: [],
      container: null,
      showMobileHot: true,
      searchTimer: null,
      resultMobile: "",
      recentCityData:[],
      showrecentCityData:false,
      objBaseInfo: {} // 存储全局属性
    };
  },
  methods: {
    //点击destination
    clickDest() {
      //判断是否进行弹框
      if (this.isHotCity) {
        this.visible = !this.visible;
      }
    },
    getCityLable(item) {
      if (this.$i18n.locale == "zh") {
        return (
          (item.locationType != 0 && item.locationType != 2
            ? item.cityCnName + ", "
            : "") +
          item.provinceCnName +
          ", " +
          item.countryCnName
        );
      } else {
        return (
          (item.locationType != 0 && item.locationType != 2
            ? item.cityEnName + ", "
            : "") +
          item.provinceEnName +
          ", " +
          item.countryEnName
        );
      }
    },
    getIcon(type) {
      let iconName = "";
      switch (type) {
        case 0:
          iconName = "city";
          break;
        case 1:
          iconName = "district";
          break;
        case 2:
          iconName = "airport";
          break;
        case 3:
          iconName = "custom";
          break;
        default:
          iconName = "city";
          break;
      }
      return iconName;
    },
    getLocationType(type) {
      let locationType = [];
      switch (type) {
        case 0:
          locationType = {"zh-CN": "城市", en: "City"};
          break;
        case 1:
          locationType = {"zh-CN": "行政区", en: "District"};
          break;
        case 2:
          locationType = {"zh-CN": "机场/火车站", en: "Airport/Railway Stations"};
          break;
        case 3:
          locationType = {"zh-CN": "公司地标", en: "Company Locations"};
          break;
        //中文：热门地标，英文：
        case 4:
          locationType = {"zh-CN": "热门地标", en: "Landmark"};
          break;
        default:
          locationType = {"zh-CN": "城市", en: "City"};
          break;
      }
      return locationType[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
    },
    async onClosePop() {
      this.showMobileHot = true;
      this.searchCity = "";
      this.returnParent = "";
      this.destPopShow = false;
      this.indexCityInfoList = [];
      if (this.cityCode) {
        this.getCityName();
      }
    },
    onInput(val) {
      // 搜索
      if (val) {
        this.showMobileHot = false;
        this.returnParent = val;
        this.querySearch();
      } else {
        this.showMobileHot = true;
        this.indexCityInfoList = [];
        this.tipMessage = "";
        clearTimeout(this.searchTimer);
      }
    },
    onCancel() {
      // 取消
      this.onClosePop();
    },
    setConfirmFlags() {
      this.confirmFlag = false;
    },
    // 输入框搜索
    querySearch() {
      clearTimeout(this.searchTimer);
      //输入后不选择 没有code，不能搜索

      this.cityCode = "";
      this.$emit("returnCityInfo", {cityCode: "",});
      if (this.objBaseInfo.channelId == "WEB") {
        this.tipMessage = "";
        if (this.returnParent.trim() === "") {
          this.showCityHot = this.isHotCity ? true : false;
          this.visible = this.isHotCity ? this.visible : false;
          this.showSelectContent = false;
          return;
        }
        this.visible = true;
        this.showCityHot = false;
       
      }
      if (this.returnParent) {
        this.searchInitCity().then(() => {
          this.showSelectContent = true;
        });
      } else {
        this.resultList = [];
        this.tipMessage = this.$t("DESTINATION.NOTDEST");
      }
    },
    //弹出窗选中值存放以及弹出框显示隐藏控制
    toParam(item, type) {
      this.getCountryList(item.countryCode);
      if (type == "search") {
        item = {
          aliasName: item.cityAliasName,
          cityCode: item.cityCode,
          cityId: item.pkid,
          cityName: item.cityCnName,
          cityNameLists: {"zh-CN": item.cityCnName, en: item.cityEnName},
          countryCode: item.countryCode,
          countryNameLists: {"zh-CN": item.countryCnName, en: item.countryEnName},
          destinationType: item.destinationType,
          frequentlyUsedFlag: item.frequentlyUsedFlag,
          geoCodeType: item.cityGeoCodeType,
          latitude: item.cityLatitude,
          longitude: item.cityLongitude,
          provinceCode: item.provinceCode,
          provinceNameLists: {en: item.provinceEnName, "zh-CN": item.provinceCnName},
          tcCode: item.tcCode,
          timeStamp: item.cityTimeStamp,
          locationName: {en: item.locationEnName, "zh-CN": item.locationCnName},
          locationCnName: item.locationCnName,
          locationCode: item.locationCode,
          locationEnName: item.locationEnName,
          locationGeoCodeType: item.locationGeoCodeType,
          locationLatitude: item.locationLatitude,
          locationLongitude: item.locationLongitude,
          locationType: item.locationType,
        };
      } else {
        item.locationType = 0;
      }
      if (this.objBaseInfo.channelId === "MOBILE") {
        this.showMobileHot = true;
        this.searchCity = "";
        this.destPopShow = false;
        this.indexCityInfoList = [];
      }
      if (this.objBaseInfo.channelId === "WEB") {
        this.showCityHot = this.isHotCity ? true : false;
        this.visible = this.isHotCity ? this.visible : false;
        this.showSelectContent = false;
        this.resultList = [];
      }
      this.returnParent = item.cityNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
      this.resultMobile = this.returnParent;
      this.cityCode = item.cityCode;
      this.$emit("returnCityInfo", {
        cityName: this.returnParent,
        cityCode: this.cityCode,
        cityInfo: item,
      });
    },
    clearSearchResult() {
      this.indexCityInfoList = [];
      this.resultList = [];
      this.tipMessage = this.$t("DESTINATION.NOTDEST");
    },
    async searchInitCity() {
      this.tipMessage = this.$t("DESTINATION.WAITSEARCHTIP");
      // 城市搜索
      let params = {
        params: {
          keyword: this.returnParent,
          pageNumber: 1,
          pageSize: 100,
          destinationType: this.isHotCity ? this.$objBaseInfo.destinationType : null,
          locationType: this.isOnlyCity ? "0" : null,
          customerCode: this.objBaseInfo.customerCode,
        },
      };
      await searchDestination(params)
        .then((res) => {
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              console.log(
                "城市信息搜索失败, code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              // this.inCityData = res.data.list;
              if (res.data.list && res.data.list.length > 0) {
                if (this.objBaseInfo.channelId == "MOBILE") {
                  this.indexCityInfoList = res.data.list;
                } else {
                  this.resultList = res.data.list;
                }
                this.tipMessage = "";
              } else {
                this.clearSearchResult();
              }
            }
          } else {
            this.clearSearchResult();
            console.log("城市信息搜索失败, code:" + res.code, res.message);
          }
        })
        .catch((err) => {
          this.clearSearchResult();
          console.log("城市信息搜索异常：", err.objError);
        });
    },
    async initCity() {
      // 热门城市
      let params = {
        params: {
          frequentlyUsedFlag: "1",
          page: 1,
          per_page: 1000,
          isEnable: 1,
          destinationType: this.objBaseInfo.destinationType,
          usercode: this.objBaseInfo.userCode,
          loginId:this.objBaseInfo.loginID,
        },
      };
      let expirationDate = sessionStorage.getItem("expirationDate");
      if(expirationDate){
        const storedTime = parseInt(expirationDate, 10);
        const currentTime = new Date().getTime();
        if((currentTime - storedTime) < 5 * 60 * 1000){
          params.params.t = new Date().getTime();
        }
      }
      await cityList(params)
        .then((res) => {
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              console.log(
                "城市信息请求失败, code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              this.inCityData = res.data.list;
              if(res.data.recentCityList != undefined && res.data.recentCityList.length >0){
                this.recentCityData = res.data.recentCityList.filter(data => data.destinationType == this.objBaseInfo.destinationType);
                this.showrecentCityData =  this.recentCityData.length > 0;
              }
            }
          } else {
            console.log("城市信息请求失败, code:" + res.code, res.message);
          }
        })
        .catch((err) => {
          console.log("城市信息请求异常：", err.objError);
        });
    },
    getCityName() {
      getCityInfoByCode(this.cityCode ? this.cityCode : this.parentCityCode).then((city) => {
        if (city) {
          this.returnParent = city.cityNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
          this.resultMobile = this.returnParent;
          this.cityCode = this.parentCityCode;
          this.$objBaseInfo.gaoDeCityCode = city?.gaoDeCityCode || '';
        }
      });
    },
    //获取搜索下拉值-国省市
    async getCountryList(countryCode) {
      let searchparams = {
        params: {
          countryCode: countryCode,
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if(res.code==200 && res.data.list.length > 0){
            this.objBaseInfo.intlTaxDisplay = res.data.list[0].intlTaxDisplay;
            this.objBaseInfo.gaoDeCountryCode = res.data.list[0]?.gaoDeCountryCode || '';
          }
        });
    },
    async revoveRecentRecord(){
      let params = {
        params: {
          usercode: this.objBaseInfo.userCode,
          loginID:this.objBaseInfo.loginID,
        },
      };
      await revoveRecentRecords(params)
        .then((res) => {
          if (res.code === 200) {
            const now = new Date().getTime();
            let expirationDate = sessionStorage.getItem("expirationDate");
            if(expirationDate){
              sessionStorage.removeItem("expirationDate");
            }
            sessionStorage.setItem("expirationDate",now);
            this.recentCityData = [];
            this.showrecentCityData = false;
          }
        });
    },
    MobileInputClick() {
      this.tipMessage = "";
      this.destPopShow = true;
    },
  },
  mounted() {
    // 获取全局属性
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
    }
    
    if(this.defaultSearchValue!="" && this.defaultSearchValue!=null && this.defaultSearchValue !=undefined)
    {
        this.returnParent=this.defaultSearchValue;
    }
    this.container = this.$refs.container;
    this.initCity();
  },
  watch: {
    returnParentValue(newValue) {
      this.returnParent = newValue || "";
    },
    parentCityCode(newCode) {
      if (newCode && this.cityCode !== newCode) {
        this.cityCode = newCode;
        this.getCityName();
      }
      if (!newCode) {
        this.$emit("returnCityInfo", {cityCode: "",});
        this.returnParent = "";
        this.resultMobile = "";
        this.cityCode = "";
      }
    },
    "$i18n.locale"() {
      if (this.cityCode || this.parentCityCode) {
        this.getCityName();
      } else {
        this.returnParent = "";
        this.resultList = this.indexCityInfoList = [];
        this.showCityHot = this.isHotCity ? true : false;
        this.visible = this.isHotCity ? this.visible : false;
        this.showSelectContent = false;
      }
    },
  },
};
</script>
<style lang="stylus">
/*手机屏幕*/
@media screen and (max-width: 960px) {
  .el-popover.dest-popover {
    min-width: 0px;
    width: 80%;
  }
  .list_city {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 7rem;
    color: $link-tab-color;
    text-align: center;
    font-size: 1.7rem;
  }
}
@media screen and (min-width: 961px) {
  .el-popover.dest-popover {
    min-width: 15rem;
    min-height: 2rem;
    width: 60rem;
  }
}
</style>
<style lang="stylus" scoped>
@media screen and (min-width: 961px) {
  .scroll_hot {
    overflow-y: auto;
    max-height: 14rem;
  }
  /* 弹出窗 热门城市面板 */
  ul{
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    box-sizing: border-box;
  }
  li {
      text-align: -webkit-match-parent;
      width: 15%;
  }
  li, ul{
    margin: 0;
      padding: 0;
      list-style: none;
  }
  ul li span{
    display: block;
    padding: 1px 5px;
    height: 30px;
    font-size: 14px;
    color: #333;
    letter-spacing: 0;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  p{
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .title{
    font-size: 14px;
    color: #666;
    background: #f7f7fb;
    height: 30px;
    line-height: 30px;
    padding-left: 8px;
    font-weight: 700;
  }
  .city-span:hover{
    background: #007aff;
    color: white;
  }
  /* 弹出窗 搜索 */
  .el-row {
    font-size: 14px;
    // padding: 5px 0px ;
  }
  .el-row:hover, .el-row:active{
    border-radius: 10px;
    background: #badbff;
  }
  .item-icon-size{
    padding-left: 1rem;
    height: 4rem;
    line-height: 5rem;
  }
  .item-type-span{
    line-height: 4rem;
    font-size: 12px;
    color: #999;
  }
  .item-name-span{
    line-height: 2.3rem;
    font-size: 1.4rem;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .item-next-span {
    font-size: 1.2rem;
    color: #999;
  }
  .item-select-row {
    padding: 0.2rem 0;
  }
  ::-webkit-scrollbar
  {
    width: 1rem;
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb
  {
    border-radius: 3;
    /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
    background-color: $scrollbar-thumb-hover-color;
  }
  .selectContent {
    max-height: 200px;
    overflow: auto;
  }
}
/*手机屏幕*/
@media screen and (max-width: 960px){
  .van-search.van-search--show-action {
    padding: 0.5rem;
  }
  .city-span.van-cell {
    padding: 1rem 2rem;
    .svg-icon {
      margin-right: 1rem;
    }
  }
  /* 弹出窗 热门城市面板 */
  ul{
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    box-sizing: border-box;
  }
  li {
      text-align: -webkit-match-parent;
      width: 33%;
  }
  li, ul{
    margin: 0;
      padding: 0;
      list-style: none;
  }
  ul li span{
    display: block;
    padding: 0.5rem;
    height: 3rem;
    font-size: 1.6rem;
    color: #333;
    letter-spacing: 0;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  p{
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .title{
    font-size: 1.6rem;
    color: #666;
    background: #f7f7fb;
    height: 3rem;
    line-height: 30px;
    padding-left: 0.5rem;
    font-weight: 700;
  }
  .city-span:hover{
    background: #007aff;
    color: white;
  }
  /* 弹出窗 搜索 */
  .el-row {
    font-size: 14px;
    padding: 5px 0px ;
  }
  .el-row:hover, .el-row:active{
    border-radius: 10px;
    background: #badbff;
  }
  .item-icon-size{
    padding-left: 1rem;
  }
  .item-type-span{
    padding-top: 4px;
    font-size: 12px;
    color: #999;
  }
  .item-name-span{
    padding-top: 5px;
    font-size: 14px;
  }
  ::-webkit-scrollbar
  {
    width: 1rem;
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb
  {
    border-radius: 3;
    /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
    background-color: $scrollbar-thumb-hover-color;
  }

  .selectContent {
    max-height: 200px;
    overflow: auto;
  }
}
</style>